import { hasClass } from '../has-class';

export function hasAnyClass(element: Element, classes: string[]): boolean {
	return element && classes.some((className) => hasClass(element, className));
}
